import React from "react";
import IoIosPeople from "react-icons/lib/io/ios-people";
import IoIosChatboxes from "react-icons/lib/io/ios-chatboxes";
import IoIosSettings from "react-icons/lib/io/android-settings";
import Nav from "../Nav/Nav";
import NavLink from "../NavLink/NavLink";
import InboxUnreadCountQuery from "../../../Inbox/components/InboxUnreadCountQuery/InboxUnreadCountQuery";

export default function Navigation(props) {
    return (
        <Nav>
            <NavLink to="/buddies">
                <IoIosPeople /> Buddies
            </NavLink>
            {props.user ? (
                <InboxUnreadCountQuery
                    render={({count}) => (
                        <NavLink to="/inbox" notification={count}>
                            <IoIosChatboxes /> Inbox
                        </NavLink>
                    )}
                />
            ) : (
                <NavLink to="/inbox" notification={0}>
                    <IoIosChatboxes /> Inbox
                </NavLink>
            )}
            <NavLink to="/settings">
                <IoIosSettings /> Settings
            </NavLink>
        </Nav>
    );
}
